import React from 'react';
import i18n from 'asset/translation';
import Dashboard, { DashboardAccessVisibility, getOwnerDisplayName } from 'domain/entity/dashboard';
import { StyledGreyTag } from 'adapter/in/reports/containers/ReportListsStyles';

export const getReportTemplateAuthorTagText = (dashboard: Dashboard): string => {
    const { access, owner } = dashboard;

    if (owner.me) {
        return i18n.t('reports.owner.ownerTagMe');
    }
    if (access.visibility === DashboardAccessVisibility.GLOBAL) {
        return i18n.t('reports.owner.ownerTagDefault');
    }
    if (access.visibility === DashboardAccessVisibility.PRIVATE && (access.groups ?? []).length === 0) {
        const ownerName = getOwnerDisplayName(owner);
        return ownerName
            ? i18n.t('reports.owner.ownerTagUser', { name: ownerName })
            : i18n.t('reports.owner.ownerTagPrivateUser');
    }
    return i18n.t('reports.owner.ownerTagOther');
};

export const useReportTemplateAuthorColumn = (onCell?: (record: any) => React.TdHTMLAttributes<HTMLElement>) => ({
    title: i18n.t('reports.columns.author'),
    dataIndex: '',
    width: '10%',
    className: 'remove-border',
    onCell,
    render: (reportTemplate: Dashboard) => {
        const text = getReportTemplateAuthorTagText(reportTemplate);
        return <StyledGreyTag>{text}</StyledGreyTag>;
    },
});
